import {useAppSelector} from "../../../store/hooks";

export function useOpenedMultileadModalRequiredParams() {
    const mainPropertyId = useAppSelector((state) => state.multilead.mainPropertyId);
    const mainVendorId = useAppSelector((state) => state.multilead.mainVendorId);
    const mainOfferId = useAppSelector((state) => state.multilead.mainOfferId);
    const source = useAppSelector((state) => state.multilead.source);
    const sourceSection = useAppSelector((state) => state.multilead.sourceSection);

    return {
        mainPropertyId,
        mainVendorId,
        mainOfferId,
        source,
        sourceSection
    };
}
import {useAppSelector} from "../../../store/hooks";

export function useOpenedMultileadModalRequiredParams() {
    const mainPropertyId = useAppSelector((state) => state.multilead.mainPropertyId);
    const mainVendorId = useAppSelector((state) => state.multilead.mainVendorId);
    const mainOfferId = useAppSelector((state) => state.multilead.mainOfferId);
    const source = useAppSelector((state) => state.multilead.source);
    const sourceSection = useAppSelector((state) => state.multilead.sourceSection);

    return {
        mainPropertyId,
        mainVendorId,
        mainOfferId,
        source,
        sourceSection
    };
}
